module.exports = __webpack_public_path__ + "img/Atelier_Smartphone.48022088.jpg";